const API_URL = 'https://rocketpaisa.codexo.in/frontend/';
const REGISTER_API_URL = 'https://login.rocketpaisa.in/'
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting , REGISTER_API_URL };